export default "__VITE_ASSET__daf3121e__"